import { Button, Form, Input, Modal } from "antd";
import { useLogs } from "../../providers/LogProvider";
import { useState } from "react";

export const AddApp = ({ onCancel }: { onCancel: () => void }) => {
  const { addApp } = useLogs();
  const [isCreating, setIsCreating] = useState(false);

  const handleCreateApp = async (name: string) => {
    if (isCreating) return;

    setIsCreating(true);
    try {
      const isSuccess = await addApp(name);
      if (isSuccess) {
        onCancel();
      }
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Modal
      title="Create application"
      open={true}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={(values) => handleCreateApp(values.name)}
        onFinishFailed={() => console.log("failed")}
        autoComplete="off"
      >
        <Form.Item
          name="name"
          rules={[
            {
              required: true,
              message: "Please input your app's name",
            },
          ]}
        >
          <Input placeholder="App name" />
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: "100%" }}
          loading={isCreating}
        >
          Create
        </Button>
      </Form>
    </Modal>
  );
};
